import {
  FETCH_PRODUCT_DETAILS,
  UPDATE_PRODUCT_DETAILS,
  SET_SELECTED_LEVEL_PROD_WIZARD,
  RESET_PROD_DETAILS_WIZARD_FORM,
  CREATE_PRODUCT_DETAILS,
  DISABLE_PROD_DETAILS_WIZARD_FORM,
  SET_SELECTED_PORTAL_PROD_WIZARD,
  FETCH_PRODUCT_DETAILS_PARENT_VALUES,
  CLEAR_PRODUCT,
  DISPLAY_PARENT_SWITCH_PROD_WIZARD,
  SET_PROD_DETAIL_FORM_GENERIC,
  SET_SELECTED_CLIENT_PROD_WIZARD
} from '../actions/types'

const initialState = {
  productDetails: {},
  selectedLevel: 'Client',
  isFormDisabled: true,
  selectedPortal: null,
  selectedClient: null,
  buttonLevelNames: [
    { name: 'Client', value: 'Client' },
    { name: 'Portal', value: 'Portal' },
    { name: 'Store View', value: 'Store View' }
  ],
  parentValues: {},
  displayParentSwitch: false,
  parentLabel: 'Parent'
}

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_PRODUCT_DETAILS:
      return {
        ...state,
        productDetails: action.payload
      }
    case UPDATE_PRODUCT_DETAILS:
      return {
        ...state,
        productDetails: action.payload
      }
    case CREATE_PRODUCT_DETAILS:
      return {
        ...state,
        productDetails: action.payload
      }
    case SET_SELECTED_LEVEL_PROD_WIZARD: {
      const btnNames = state.buttonLevelNames
      const currentLevelIndex = btnNames.findIndex(level => level.value === action.payload)
      const parentLabel = currentLevelIndex > 0 ? btnNames[currentLevelIndex - 1].name : 'Parent'
      return {
        ...state,
        selectedLevel: action.payload,
        parentLabel
      }
    }
    case RESET_PROD_DETAILS_WIZARD_FORM:
      return {
        ...state,
        selectedLevel: 'Client',
        displayParentSwitch: false,
        buttonLevelNames: initialState.buttonLevelNames
      }
    case DISABLE_PROD_DETAILS_WIZARD_FORM:
      return {
        ...state,
        isFormDisabled: action.payload
      }
    case SET_SELECTED_PORTAL_PROD_WIZARD:
      return {
        ...state,
        selectedPortal: action.payload
      }
    case FETCH_PRODUCT_DETAILS_PARENT_VALUES:
      return {
        ...state,
        parentValues: action.payload
      }
    case CLEAR_PRODUCT:
      return {
        ...state,
        productDetails: {}
      }
    case DISPLAY_PARENT_SWITCH_PROD_WIZARD:
      return {
        ...state,
        displayParentSwitch: action.payload
      }
    case SET_PROD_DETAIL_FORM_GENERIC:
      return {
        ...state,
        selectedLevel: 'Generic',
        buttonLevelNames: [{ name: 'Generic', value: 'Generic' }, ...initialState.buttonLevelNames]
      }
    case SET_SELECTED_CLIENT_PROD_WIZARD:
      return {
        ...state,
        selectedClient: action.payload
      }
    default:
      return state
  }
}
